
























































































import { Component, Vue, Prop, PropSync, Watch, InjectReactive } from 'vue-property-decorator';
import { GQL_EmployeeTaxCardEmployeeSave } from '@/queries/global';
import { generateUID, WithUID } from '@/utils/utils';
import EmployeeTaxCardForm from './EmployeeTaxCardForm.vue';
import PermissionService from '@/utils/permission-service';
import { buildNewEmployeeTaxCard, isOlderTaxCard } from '@/app/Employee';
import dayjs from '@/utils/dayjs';

@Component({
  components: {
    EmployeeTaxCardForm,
  },
})
export default class EmployeeTaxCardsTableForm extends Vue {
  @Prop({ type: Array, required: true }) private employeeTaxCards!: WithUID<GQL_EmployeeTaxCardEmployeeSave>[];
  @PropSync('valid', { type: Boolean, default: true }) private validFormSync!: boolean;

  @InjectReactive() private editable!: boolean;

  private validTaxCardForms: { [uid: string]: boolean } = {};

  private PermissionService = PermissionService;

  private showOlderTaxCards = false;

  // Ids of the cards that were saved when the page was opened. Only those
  // can be folded away, so a card added and saved during this visit stays.
  private idsAtLoad: Set<string> | null = null;

  // Decided once per card, from its saved calendar year, so a card does
  // not disappear while its year is being edited.
  private foldableTaxCards: { [uid: string]: boolean } = {};

  private get notDeletedEmployeeTaxCards(): WithUID<GQL_EmployeeTaxCardEmployeeSave>[] {
    return this.employeeTaxCards.filter(taxCard => !taxCard._destroy);
  }

  private get foldedEmployeeTaxCards(): WithUID<GQL_EmployeeTaxCardEmployeeSave>[] {
    if (this.showOlderTaxCards) return [];
    return this.notDeletedEmployeeTaxCards.filter(taxCard => this.foldableTaxCards[taxCard.$_UID]);
  }

  private get shownEmployeeTaxCards(): WithUID<GQL_EmployeeTaxCardEmployeeSave>[] {
    return this.notDeletedEmployeeTaxCards.filter(taxCard => !this.foldedEmployeeTaxCards.includes(taxCard));
  }

  @Watch('employeeTaxCards', { immediate: true })
  private ensureUIDsAreSet(): void {
    if (!this.idsAtLoad) {
      this.idsAtLoad = new Set(this.employeeTaxCards.map(taxCard => taxCard.id).filter((id): id is string => !!id));
    }
    const currentYear = dayjs().year();

    this.employeeTaxCards.forEach(taxCard => {
      if (!taxCard.$_UID) {
        taxCard.$_UID = generateUID();
        Vue.set(this.validTaxCardForms, taxCard.$_UID, true);
        Vue.set(
          this.foldableTaxCards,
          taxCard.$_UID,
          !!taxCard.id && this.idsAtLoad!.has(taxCard.id) && isOlderTaxCard(taxCard, currentYear),
        );
      }
    });
  }

  private addTaxCard(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const taxCard: any = buildNewEmployeeTaxCard();
    taxCard.$_UID = generateUID();
    this.employeeTaxCards.push(taxCard as WithUID<GQL_EmployeeTaxCardEmployeeSave>);
  }

  private removeTaxCard(taxCard: WithUID<GQL_EmployeeTaxCardEmployeeSave>): void {
    if (taxCard.id) {
      Vue.set(taxCard, '_destroy', true);
    } else {
      this.employeeTaxCards.splice(
        this.employeeTaxCards.indexOf(taxCard),
        1,
      );
    }
  }

  @Watch('employeeTaxCards')
  @Watch('validTaxCardForms', { deep: true })
  private setValidFormSync(): void {
    this.validFormSync = this.notDeletedEmployeeTaxCards.every(taxCard => this.validTaxCardForms[taxCard.$_UID]);
  }
}
